export const FONT_SMALL = 'FONT_SMALL';
export const FONT_BASE = 'FONT_BASE';
export const FONT_NORMAL = 'FONT_NORMAL';
export const FONT_MEDIUM = 'FONT_MEDIUM';
export const FONT_BIG = 'FONT_BIG';
export const FONT_BIGGER = 'FONT_BIGGER';

const fontSizeMap = {
    small: '11px',
    base: '12px',
    normal: '14px',
    medium: '16px',
    big: '20px',
    bigger: '24px'
};

const fontSizes = {};
fontSizes[FONT_SMALL] = fontSizeMap.small;
fontSizes[FONT_BASE] = fontSizeMap.base;
fontSizes[FONT_NORMAL] = fontSizeMap.normal;
fontSizes[FONT_MEDIUM] = fontSizeMap.medium;
fontSizes[FONT_BIG] = fontSizeMap.big;
fontSizes[FONT_BIGGER] = fontSizeMap.bigger;

export function themeFontSize(param: string) {
    if (!fontSizes.hasOwnProperty(param)) {
        throw new Error(`${param} is not a defined font-size.`);
    }
    return fontSizes[param];
}
